'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _helpers = require('../common/helpers');

var _staticProperties = require('./staticProperties');

var staticProperties = _interopRequireWildcard(_staticProperties);

var _dynamicProperties = require('./dynamicProperties');

var dynamicProperties = _interopRequireWildcard(_dynamicProperties);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getStaticProperties = (0, _helpers.once)(staticProperties.get);

/*
*  metaProperties = properties that get stamped to each event
*   staticProperties = properties that get set once on page load
*   dynamicProperties = properties that can change for each event
*/
var get = exports.get = function get(_ref) {
  var getTempStorage = _ref.getTempStorage,
      setTempStorage = _ref.setTempStorage;
  return _extends({}, getStaticProperties(), dynamicProperties.get({ getTempStorage: getTempStorage, setTempStorage: setTempStorage }));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.104/js/metaProperties/index.js
// module id = 1244
// module chunks = 3